import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';

@Pipe({
  name: 'getCountByProperty',
  standalone: false,
})
export class GetCountByPropertyPipe implements PipeTransform {
  transform(list: DataObject[], attrName: string, attrValue: any): number {
    if (list == null || !Array.isArray(list) || attrName == null) return 0;
    return (list ?? []).filter(l => l[attrName] == attrValue).length;
  }
}
